import React from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';
import type { CreateItemPayload } from '../types';

const { Option } = Select;

interface AddItemModalProps {
    open: boolean;
    onCancel: () => void;
    onAdd: (values: CreateItemPayload) => Promise<boolean>;
}

export const AddItemModal: React.FC<AddItemModalProps> = ({ open, onCancel, onAdd }) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = React.useState(false);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setSubmitting(true);
            const success = await onAdd(values);
            if (success) {
                form.resetFields();
                onCancel();
            }
        } catch (error) {
            // Validation failed
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title="添加自定义检查项"
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            confirmLoading={submitting}
        >
            <Form form={form} layout="vertical">
                <Form.Item name="name" label="检查项名称" rules={[{ required: true }]}>
                    <Input placeholder="例如: 是否有圣诞节促销图" />
                </Form.Item>
                <Form.Item name="category" label="分类" rules={[{ required: true }]}>
                    <Select>
                        <Option value="media">视觉/媒体</Option>
                        <Option value="text">文案/内容</Option>
                        <Option value="price">价格/促销</Option>
                        <Option value="social">评论/口碑</Option>
                        <Option value="traffic">流量/转化</Option>
                        <Option value="other">其他</Option>
                    </Select>
                </Form.Item>
                <Form.Item name="value_type" label="值类型" initialValue="bool">
                    <Select>
                        <Option value="bool">是/否 (Yes/No)</Option>
                        <Option value="text">文本 (Text)</Option>
                        <Option value="number">数值 (Number)</Option>
                    </Select>
                </Form.Item>
                <Form.Item name="description" label="判断标准/描述">
                    <Input.TextArea rows={3} placeholder="描述判断的具体标准..." />
                </Form.Item>
            </Form>
        </Modal>
    );
};
